import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Mount inside <BrowserRouter>. On route change:
 *  - if the URL has a `#hash`, smoothly scroll to that element (after paint),
 *  - otherwise scroll the window to the top so every page starts at the top.
 * Fixes the bug where clicking a nav link from a different route (e.g. #services
 * while on /reviews/) left the visitor at the bottom of the previous page.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      // Wait a tick for the target page to render its DOM
      const id = hash.replace(/^#/, "");
      const scroll = () => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
        else window.scrollTo({ top: 0, behavior: "auto" });
      };
      const t = window.setTimeout(scroll, 60);
      return () => window.clearTimeout(t);
    }
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [pathname, hash]);

  return null;
}
